import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=fc4106ec&scoped=true&"
import script from "./StackedBarChart.vue?vue&type=script&lang=js&"
export * from "./StackedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4106ec",
  null
  
)

export default component.exports